import { render, staticRenderFns } from "./IconSvgSnmmiPodcast.vue?vue&type=template&id=6ab06e6e&scoped=true&"
import script from "./IconSvgSnmmiPodcast.vue?vue&type=script&lang=js&"
export * from "./IconSvgSnmmiPodcast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab06e6e",
  null
  
)

export default component.exports